module.exports = __webpack_public_path__ + "img/hadjidraganovi2.0f143c90.jpg";